import type { BoardDefinition } from '../types';

/**
 * Format a scope object as a display label.
 * Works for any entity with a scope (ADR, Resource, etc.).
 *
 * @param scope - The scope object with type and optional boardId
 * @param boardMap - Map of boardId -> BoardDefinition for name lookup
 * @param labels - Translation labels for scope types
 */
export function getScopeLabel(
  scope: { type: 'global' } | { type: 'board'; boardId: string } | { type: 'canvas'; boardId: string; treeId?: string },
  boardMap: Map<string, BoardDefinition>,
  labels: { global: string; board: string; canvas: string },
): string {
  if (scope.type === 'global') return labels.global;
  if (scope.type === 'board') {
    const board = boardMap.get(scope.boardId);
    return board ? board.name : labels.board;
  }
  const board = boardMap.get(scope.boardId);
  return board ? `${board.name} > ${labels.canvas}` : labels.canvas;
}
